import FilterDropdown from './filter-dropdown.jsx';
import './filter-dropdown.scss';

export default FilterDropdown;
